import Phaser from 'phaser';
import { TEX } from '@/data/assetManifest';

// Map-base PNG manifest. Each entry maps a "map key" (matches FieldTheme /
// MapKey or 'lorencia' for TownScene) to its texture key + URL on disk.
// Loaded lazily by ensureMapBase() so PreloadScene no longer pulls every
// base image up-front (saves bandwidth & memory when only one map is in use).
export const MAP_BASES: Record<string, { texKey: string; url: string }> = {
  lorencia: { texKey: TEX.lorenciaBase, url: '/assets/maps/lorencia-base.png' },
  noria:    { texKey: TEX.noriaBase,    url: '/assets/maps/noria-base.png' },
  devias:   { texKey: TEX.deviasBase,   url: '/assets/maps/devias-base.png' },
  atlans:   { texKey: TEX.atlansBase,   url: '/assets/maps/atlans-base.png' },
  dungeon:  { texKey: TEX.dungeonBase,  url: '/assets/maps/dungeon-base.png' },
  tarkan:   { texKey: TEX.tarkanBase,   url: '/assets/maps/tarkan-base.png' },
  icarus:   { texKey: TEX.icarusBase,   url: '/assets/maps/icarus-base.png' },
  kalima:   { texKey: TEX.kalimaBase,   url: '/assets/maps/kalima-base.png' },
  blood_castle: { texKey: TEX.bloodCastleBase, url: '/assets/maps/blood_castle-base.png' },
  devil_square: { texKey: TEX.devilSquareBase, url: '/assets/maps/devil_square-base.png' },
  chaos_castle: { texKey: TEX.chaosCastleBase, url: '/assets/maps/chaos_castle-base.png' },
  illusion_temple: { texKey: TEX.illusionTempleBase, url: '/assets/maps/illusion_temple-base.png' },
  crywolf: { texKey: TEX.crywolfBase, url: '/assets/maps/crywolf-base.png' },
  swamp_of_calmness: { texKey: TEX.swampOfCalmnessBase, url: '/assets/maps/swamp_of_calmness-base.png' },
  castle_siege: { texKey: TEX.castleSiegeBase, url: '/assets/maps/castle_siege-base.png' },
  golden_invasion: { texKey: TEX.goldenInvasionBase, url: '/assets/maps/golden_invasion-base.png' },
  hero_dungeon: { texKey: TEX.heroDungeonBase, url: '/assets/maps/hero_dungeon-base.png' },
  lorencia_outskirt: { texKey: TEX.lorenciaOutskirtBase, url: '/assets/maps/lorencia_outskirt-base.png' },
};

// Ensure the base PNG for `mapKey` is loaded into the scene's texture cache.
// No-op when the map has no base image or the texture is already present.
export function ensureMapBase(scene: Phaser.Scene, mapKey: string): Promise<void> {
  const entry = MAP_BASES[mapKey];
  if (!entry) return Promise.resolve();
  if (scene.textures.exists(entry.texKey)) return Promise.resolve();
  return new Promise<void>((resolve) => {
    scene.load.image(entry.texKey, entry.url);
    scene.load.once(Phaser.Loader.Events.COMPLETE, () => resolve());
    scene.load.once(Phaser.Loader.Events.FILE_LOAD_ERROR, () => resolve());
    scene.load.start();
  });
}
